import { useTranslation } from "react-i18next";
import { ShoppingCart, DollarSign, Trophy } from "lucide-react";

/**
 * Compact "How to Play" strip shown on the Lobby so first-time users can
 * grasp the core loop within ~10 seconds. Three icon-bullets, no modal.
 */
export default function HowToPlayStrip() {
  const { t } = useTranslation();
  const steps = [
    {
      icon: ShoppingCart,
      color: "text-[#00E676]",
      bg: "bg-[#00E676]/15",
      label: t("howToPlay.step1.label"),
      sub: t("howToPlay.step1.sub"),
    },
    {
      icon: DollarSign,
      color: "text-[#38B6FF]",
      bg: "bg-[#38B6FF]/15",
      label: t("howToPlay.step2.label"),
      sub: t("howToPlay.step2.sub"),
    },
    {
      icon: Trophy,
      color: "text-[#FFC107]",
      bg: "bg-[#FFC107]/15",
      label: t("howToPlay.step3.label"),
      sub: t("howToPlay.step3.sub"),
    },
  ];

  return (
    <div
      className="mb-6 rounded-2xl bg-white/60 dark:bg-slate-900/60 backdrop-blur border border-[#1A237E]/10 dark:border-[#E3F2FD]/10 px-3 py-3 sm:px-4 sm:py-3"
      data-testid="how-to-play-strip"
    >
      <div className="flex items-center justify-between gap-2 sm:gap-3">
        <span
          className="hidden sm:inline text-[10px] font-bold uppercase tracking-[0.15em] text-[#1A237E]/60 dark:text-[#E3F2FD]/60 shrink-0"
          style={{ fontFamily: "Fredoka" }}
        >
          {t("howToPlay.label")}
        </span>
        <div className="flex-1 grid grid-cols-3 gap-1.5 sm:gap-3">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                className="flex items-center gap-2 min-w-0"
                data-testid={`how-to-play-step-${i + 1}`}
              >
                <div
                  className={`shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full ${s.bg} flex items-center justify-center`}
                >
                  <Icon className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${s.color}`} />
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] sm:text-sm font-bold text-[#1A237E] dark:text-[#E3F2FD] leading-none truncate">
                    {s.label}
                  </p>
                  <p className="text-[10px] sm:text-[11px] text-[#1A237E]/55 dark:text-[#E3F2FD]/55 leading-tight truncate hidden sm:block">
                    {s.sub}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
